import { FC, Fragment, useState } from "react";
import Wrapper from "./SectionWrapper";
import StaticImageUploader from "./StaticImageUploader";
import SlidingImgUploader from "./SlidingImgUploader";
import AuctionStaticImageUploader from "./AuctionStaticImageUploader/AuctionStaticImageUploader";
import {
    AuctionBannerWrapper,
  AuctionWrapper,
  TabMenuOption,
  TabMenuOptions,
} from "./StyledPromotions";

interface AuctionProps {
  auctionPromotionList: any;
}
interface showProp {
  slider: boolean;
  left: boolean;
  right: boolean;
}

const Auction: FC<AuctionProps> = (props) => {
  const { auctionPromotionList } = props;
  const [show, setShow] = useState<showProp>({
    slider: true,
    left: false,
    right: false,
  });

  const staticImgObj = auctionPromotionList.filter((filterObj) => {
    return filterObj.promotionType === "STATIC";
  })[0];
  const staticLeftImgObj = auctionPromotionList.filter((filterObj) => {
    return (
      filterObj.promotionType === "STATIC" &&
      filterObj.promotionPosition === "LEFT"
    );
  })[0];
  const staticRightImgObj = auctionPromotionList.filter((filterObj) => {
    return (
      filterObj.promotionType === "STATIC" &&
      filterObj.promotionPosition === "RIGHT"
    );
  })[0];

  console.log(staticLeftImgObj, staticRightImgObj);

  const slidingImgs = auctionPromotionList.filter((filterObj) => {
    return filterObj.promotionType !== "STATIC";
  });

  const [tabmenuArray, setTabmenuArray] = useState([
    {
      label: "Slider",
      id: "Slider",
      isSelected: true,
    },
    {
      label: "Left",
      id: "Left",
      isSelected: false,
    },
    {
      label: "Right",
      id: "Right",
      isSelected: false,
    },
  ]);
  const toggleTabMenu = (menuId: string) => {
    setTabmenuArray(
      tabmenuArray.map((menuObj) => {
        if (menuId === "Slider") {
          setShow({
            slider: true,
            left: false,
            right: false,
          });
        } else if (menuId === "Left") {
          setShow({
            slider: false,
            left: true,
            right: false,
          });
        } else if (menuId === "Right") {
          setShow({
            slider: false,
            left: false,
            right: true,
          });
        }
        return {
          ...menuObj,
          isSelected: menuId === menuObj.id,
        };
      })
    );
  };

  let tabMenuView = tabmenuArray.map((menuObj) => {
    return (
      <TabMenuOption
        onClick={() => {
          toggleTabMenu(menuObj.id);
        }}
        key={menuObj.id}
        isSelected={menuObj.isSelected}
      >
        {menuObj.label}
      </TabMenuOption>
    );
  });

  return (
    <Fragment>
      <AuctionWrapper>
        <TabMenuOptions>{tabMenuView}</TabMenuOptions>
        <AuctionBannerWrapper>
        {show.slider && (
          <Wrapper title={"Slider Banner"}>
            <SlidingImgUploader slidingImgs={slidingImgs} />
          </Wrapper>
        )}

        {show.left && (
          <Wrapper title="Auction Left Banner">
            <AuctionStaticImageUploader
              details={staticLeftImgObj}
              bannerRedirectionUrl={""}
              promotionPosition={"LEFT"}
            />
          </Wrapper>
        )}
        {show.right && (
          <Wrapper title="Auction Right Banner">
            <AuctionStaticImageUploader
              details={staticRightImgObj}
              bannerRedirectionUrl={""}
              promotionPosition={"RIGHT"}
            />
          </Wrapper>
        )}
        </AuctionBannerWrapper>
      </AuctionWrapper>
    </Fragment>
  );
};

export default Auction;
